import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PDPGalleryLabels from 'components/consumer/PDP/PDPGalleryLabels';
const PDPGalleryLabelsAndViewingCount = t0 => {
  const $ = _c(6);
  const {
    mode: t1
  } = t0;
  const mode = t1 === undefined ? "pdp" : t1;
  const t2 = mode === "pdp";
  const t3 = mode === "quickview";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("bg-yellow-light rounded flex h-[25px] pointer-events-none hover:cursor-target [&_>_*]:ml-2 [&_>_*:first-child]:ml-0 max-[1023px]:md:mt-10", {
      "PDPGalleryLabelsAndViewingCount--mode-pdp": t2,
      "max-[1023px]:md:mt-0": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PDPGalleryLabels />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <div className={t4}>{t5}</div>;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
PDPGalleryLabelsAndViewingCount.propTypes = {
  mode: PropTypes.oneOf(['pdp', 'quickview'])
};
export default PDPGalleryLabelsAndViewingCount;